export default __webpack_public_path__ + "static/media/bank-building.bed490ee.svg";